import { top20Filters } from './constants'

export function cityIdExistsInTop20Filters(cityId: string | undefined): cityId is keyof typeof top20Filters {
  return cityId !== undefined && cityId in top20Filters
}
